import * as React from "react";
import { FaStar, FaGoogle } from "react-icons/fa";
import "twin.macro";

// ─────────────────────────────────────────────────────────────────
// ECHTE GOOGLE BEWERTUNGEN – NUR MIT ECHTEM NAMEN
// Quelle: https://share.google/qgDxVg4F9bDVb8KNp
// Bitte fehlende Bewertungen hier ergänzen.
// ─────────────────────────────────────────────────────────────────
const REVIEWS = [
  {
    name: "Sascha Hildebrandt",
    stars: 5,
    text: "Wir können A & F Garten- und Landschaftsbau aus voller Überzeugung empfehlen! Von der ersten Kontaktaufnahme bis zur Fertigstellung unseres Projekts lief alles absolut professionell, zuverlässig und freundlich ab. Besonders beeindruckt hat uns die saubere und präzise Arbeitsweise. Auch das Preis-Leistungs-Verhältnis ist absolut fair. Unser Garten hat sich komplett verändert und wir freuen uns jeden Tag darüber.",
    date: "vor einem Jahr",
  },
  {
    name: "Charlotte Ruhrmann",
    stars: 5,
    text: "Gärtner mit viel Power und Elan. In zwei Tagen war der Garten fertig gestaltet. Ein Termin ist immer möglich, trotz der Sommersaison. Prima, lieben Dank.",
    date: "vor einem Jahr",
  },
  {
    name: "Delav Abdi",
    stars: 5,
    text: "Ich bin absolut begeistert von der Arbeit von A&F Garten- und Landschaftsbau! Das Team hat unsere Wünsche nicht nur umgesetzt, sondern mit eigenen kreativen Ideen perfekt ergänzt. Die Ausführung war sauber und termingerecht – man merkt sofort, dass hier echte Profis am Werk sind. Unser Garten ist jetzt ein echter Wohlfühlort geworden, und wir bekommen ständig Komplimente dafür.",
    date: "vor einer Woche",
  },
];

function Stars({ count }) {
  return (
    <div tw="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <FaStar key={i} size={18} color={i <= count ? "#f59e0b" : "#e5e7eb"} />
      ))}
    </div>
  );
}

export default function Reviews() {
  return (
    <section id="bewertungen" tw="bg-gray-50 py-24 px-6">
      <div tw="container mx-auto">
        {/* Header */}
        <div tw="text-center mb-16">
          <div tw="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-full px-5 py-2 mb-6 shadow-sm">
            <FaGoogle size={18} color="#4285F4" />
            <span tw="font-medium text-gray-700">Google Bewertungen</span>
          </div>
          <h2 tw="text-4xl lg:text-5xl font-medium text-secondary leading-tight">
            Was unsere Kunden{" "}
            <span tw="text-primary">über uns sagen</span>
          </h2>
          <div tw="mt-6 inline-flex flex-col items-center">
            <div tw="flex gap-1">
              {[1, 2, 3, 4, 5].map((i) => (
                <FaStar key={i} size={32} color="#f59e0b" />
              ))}
            </div>
            <p tw="mt-2 text-2xl font-bold text-secondary">
              5,0{" "}
              <span tw="text-base font-normal text-gray-500">
                · {REVIEWS.length} Bewertungen auf Google
              </span>
            </p>
          </div>
        </div>

        {/* Cards */}
        <div tw="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {REVIEWS.map((review, idx) => (
            <div
              key={idx}
              tw="bg-white rounded-2xl p-6 shadow-md flex flex-col gap-4"
            >
              <Stars count={review.stars} />
              <p tw="text-gray-700 leading-relaxed flex-1">
                &ldquo;{review.text}&rdquo;
              </p>
              <div tw="flex items-center justify-between pt-2 border-t border-gray-100">
                <div>
                  <p tw="font-semibold text-secondary">{review.name}</p>
                  <p tw="text-sm text-gray-400">{review.date}</p>
                </div>
                <FaGoogle size={20} color="#4285F4" tw="opacity-60" />
              </div>
            </div>
          ))}
        </div>

        {/* CTA to Google */}
        <div tw="text-center mt-12">
          <a
            href="https://share.google/qgDxVg4F9bDVb8KNp"
            target="_blank"
            rel="noopener noreferrer"
            tw="inline-flex items-center gap-2 text-primary font-medium hover:underline text-lg"
          >
            <FaGoogle size={18} />
            Alle Bewertungen auf Google ansehen
          </a>
        </div>
      </div>
    </section>
  );
}
